module.exports = __webpack_public_path__ + "img/trinpod-server-globe.7bbb7883.png";